module.exports = __webpack_public_path__ + "img/B8.5a3d3f36.png";